import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";


const Chapter24 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>
                {/* Chapter 24 */}
                <section id="section24" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">
                        {language.chapter24Title}
                    </h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter24Paragraph1}
                    </p>
                    <p className="drivers-handbook-paragraph">
                       {language.chapter24Paragraph2}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter24Paragraph3}


                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter24Paragraph4}

                    </p>

                    <ul className="drivers-handbook-list">
                        <li>{language. chapter24List11}</li>
                        <li>{language. chapter24List12}

                        </li>
                        <li>{language. chapter24List13}
                        </li>

                        <ul className="drivers-handbook-list">
                            <li>{language.chapter24SubList11}</li>
                            <li>{language.chapter24SubList12}</li>
                            <li>{language.chapter24SubList13}</li>
                            <li>{language.chapter24SubList14}</li>
                        </ul>


                    </ul>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter24Paragraph5}


                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter24Paragraph6}

                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter24Paragraph7}
                    </p>
                    <p className="drivers-handbook-paragraph">
                       {language.chapter24Paragraph8}

                    </p>
                </section>
        </>
    )

}

export default Chapter24;
